import {displayError} from '../browser/app/errorDisplayer';
import {defineMessages} from 'react-intl';
import {getMessages} from '../browser/getMessages';
import {lastPanelController} from '../browser/view/EmbededPanelController';
import {sendMessage} from '../browser/view/EmbededPanelController';
import {sendToExtension} from '../browser/app/ExtensionCommunicate';
import {LoadingLine} from '../browser/loadingLine/renderLoadingPanel.react';
import IotClient from '../common/util/IotClient';

defineMessages({
	outlookError: {id: 'outlookExtension.dialog.message', 'defaultMessage': 'Cannot open screen settings due outlook error:'}
});

export const OUTLOOK_HASH = "#outlook";

export function openDialog(path, callback, dialogOptions = {}) {
	dialogOptions.displayInIframe = false;

	if (window.parent && window.parent.Office.context && window.parent.Office.context.ui && window.parent.Office.context.ui.displayDialogAsync) {
		window.parent.Office.context.ui.displayDialogAsync(window.location.origin + path, dialogOptions, (result) => {
			if (result.value) {
				if (!callback) {
					// default callback is panel reload
					callback = () => {
						// cannot call reloadDativery as that is extension function
						window.parent.location.reload();
					};
				}
				result.value.addEventHandler(window.parent.Microsoft.Office.WebExtension.EventType.DialogEventReceived, callback);
			}
			// 12009 - user disallow open dialog -> his conscious action doesn't need showing error
			else if (result.error && 12009 !== result.error.code) {
				let message = 'Cannot open screen settings due outlook error:';
				try {
					let tranlatedMessage = getMessages()['outlookExtension.dialog.message'];
					if (tranlatedMessage) {
						message = tranlatedMessage;
					}
				}
				catch (e) {}

				displayError(message + ' ' + result.error.message, false);
			}
		});
	}
	else {
		IotClient.listen('panel/', (message) => {
			if (message.action && message.action === 'reload') {
				IotClient.end();
				window.parent.location.reload();
			}
		}, this);
		window.open(window.location.origin + path + OUTLOOK_HASH, '_blank');
	}
}

export function sendReloadPanelForDetachedSettings(iotTopic) {
	if (isDetachedScreenSettings) {
		IotClient.setConfig(iotTopic).connect();

		window.onbeforeunload = () => {
			IotClient.publish('panel/', {
				action: 'reload'
			});
		};
	}
}

export let isOutlookPanel = (dialogOnly) => {
	if (!(typeof window === 'object' && 'location' in window)) {
		return false;
	}

	let query = window.location.search.substring(1).split('|');
	let isDialog = query.indexOf('isDialog') !== -1;
	let isOutlook = query.indexOf('_host_Info=outlook') !== -1;

	if (isOutlook && isDialog) {
		return true;
	}

	if (lastPanelController && lastPanelController() && 'com.microsoft.outlook' === lastPanelController().state.app && !dialogOnly) {
		return true;
	}

	if (isDetachedScreenSettings()) {
		return true;
	}

	return false;
};

export function isDetachedScreenSettings() {
	// now it is used only for outlook settings
	return window.location.hash === OUTLOOK_HASH;
}

if (isOutlookPanel(true)) {
	document.body.classList.add('outlook');
}

export function isScreenSettingsOnlyIframe() {
	return window.name === 'dativery-iframe-dativery-screen-seetings-panel-iframe';
}

let screenId;
export function registerScreenId(id) {
	screenId = id;
}

let channelId;
export function registerChannelId(id) {
	channelId = id;
}
export function screenSettingsOnlyClose() {
	LoadingLine.start();

	sendToExtension({
		message: 'dativery-reload-application',
		data: {
			channelId: channelId
		}
	}).then(() => {
		sendMessage({
			msg: 'dativeryScreenSettingsClose',
			screenId: screenId,
		});
	}).catch((e) => {
        displayError(e);
	});
}

const embeddedLoginQuery = '?embeddedLogin=true';
export function setEmbededLoginToPath(path) {
	return path + embeddedLoginQuery;
}

export function isEmbeddedLogin() {
	return window.location.search === embeddedLoginQuery;
}
